import { render } from "./CalendarAttendance.vue?vue&type=template&id=10bc19b4"
import script from "./CalendarAttendance.vue?vue&type=script&lang=js"
export * from "./CalendarAttendance.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__